{
  "accountPage": {
    "header": {
      "accountTypes": "Account types",
      "newUsersSetup": "New users will be added as"
    },
    "types": {
      "general": "General",
      "admin": "Admin",
      "restricted": "Restricted",
      "anonymous": "Anonymous"
    },
    "table": {
      "headers": {
        "accountType": "Account Type",
        "accessActivity": "Access to Activity?",
        "accessSettings": "Access to Settings?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Limited to shared Assets & Groups",
        "generalToSettingsNote": "Limited to Assets & People"
      }
    },
    "info": {
      "header": "Account Types explained",
      "admin": "Ideal for workplace owners, senior managers, and office administrators.",
      "general": "Ideal for full-time staff and employees. (Our recommended default.)",
      "restricted": "Ideal for known visitors, vendors, part-time workers, and contractors who require partial or limited access.",
      "anonymous": "For individuals who have not signed up with Gripp. They can only submit Reports, Notes or Routines based on what they scan."
    },
    "menu": {
      "accountPage": "Account",
      "settingsPage": "Settings",
      "workspaceSettingsPage": "Workspace Settings"
    },
    "workplaceTitle": "Workplace Management & Data",
    "downloadData": "Download Data",
    "dataExport": {
      "cancel": "Cancel",
      "title": "Data Export",
      "download": "Download"
    }
  },
  "account": {
    "allWorkspaces": "All Workspaces",
    "create": {
      "button": "Add User",
      "form": {
        "email": "Email",
        "firstName": "First Name",
        "lastName": "Last Name",
        "role": "Role"
      },
      "validation": {
        "emailRequired": "Email is required",
        "role": "Role is required",
        "validEmail": "Please enter a valid email"
      }
    },
    "filter": {
      "apply": "Apply",
      "columnSelection": "Columns",
      "columns": {
        "createdAt": "Date Joined",
        "createdDate": "Date Joined",
        "createdTime": "Time Joined",
        "email": "Email",
        "groups": "Groups",
        "groupNames": "Group Names",
        "assets": "Assets",
        "jobTitle": "Job Title",
        "location": "Location",
        "name": "Name (required)",
        "phone": "Phone Number",
        "roles": "Account Type",
        "workspace": "Workspace"
      },
      "searchPlaceholder": "Search name, number, or email",
      "columnButton": "Columns",
      "groupsButton": "Groups",
      "accountTypesButton": "Account Types",
      "noAccountTypes": "No Account Types",
      "groups": "Groups",
      "accountTypes": "Account Types",
      "default": "Default",
      "viewResults": "View {{count}} results"
    },
    "groups": {
      "addPeopleTo": "Add {{count}} people to:",
      "addPersonTo": "Add 1 person to:"
    },
    "list": {
      "accountType": "Account Type",
      "added": "Date Joined",
      "createdDate": "Date Joined",
      "createdTime": "Time Joined",
      "email": "Email",
      "groups": "Groups",
      "assets": "Assets",
      "jobTitle": "Job Title",
      "location": "Location",
      "name": "Name",
      "phone": "Phone Number",
      "workspace": "Workspace"
    },
    "topBar": {
      "peopleSelected": "{{count}} people selected",
      "personSelected": "1 person selected"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Yes",
        "secondaryButton": "Cancel",
        "title": "Are you sure you want to remove {{accountName}}?"
      }
    },
    "detail": {
      "removeAccount": "Remove Account"
    }
  },
  "activity": {
    "filter": {
      "cancel": "Cancel",
      "groups": "Groups",
      "activityOptions": "Activity Options",
      "activityTypes": "Activity Types",
      "options": "Options",
      "types": "Types",
      "notes": "Notes",
      "note": "Note",
      "pending": "Pending",
      "reset": "Reset",
      "routines": "Routines",
      "searchPlaceholder": "Search activity titles or asset name",
      "searchLabels": "Search labels",
      "solved": "Solved",
      "title": "Filters",
      "labels": "Labels",
      "urgent": "Urgent",
      "date": "Date",
      "all": "All",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "today": "Today",
      "thisWeek": "Past 7 days",
      "thisMonth": "Past 30 days",
      "custom": "Custom",
      "customDate": "Custom Date",
      "from": "From",
      "to": "To",
      "mentions": "Mentions",
      "scheduled": "Scheduled",
      "default": "Default",
      "notScheduled": "Not Scheduled",
      "pinned": "Pinned",
      "everything": "Everything",
      "onlyMentions": "Only mentions",
      "onlyPinned": "Only pinned",
      "onlyScheduled": "Only scheduled",
      "sort": "Sort",
      "viewResults": "View {{count}} results",
      "combinedGroups": "Combined filtering",
      "notGrouped": "Not Grouped",
      "notLabeled": "Not Labeled"
    },
    "search": {
      "title": "Search",
      "search": "Search",
      "recentSearches": "Recent Searches"
    },
    "sort": {
      "mostRecent": "Last Updated",
      "reminderDate": "Reminder Date",
      "oldest": "Creation Date"
    },
    "header": {
      "title": "Activity",
      "view": "View",
      "viewAll": "View All"
    },
    "list": {
      "youAreMentioned": "You are mentioned."
    },
    "menu": {
      "title": "Activity",
      "titlePlural": "Activities"
    },
    "textEmpty": "No activity",
    "topBar": {
      "results": "results"
    },
    "edit": {
      "tab": {
        "activity": "Activity",
        "routine": "Routine"
      }
    },
    "tapScan": "Tap “+” to scan assets or invitation codes.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Join a workspace!",
        "description": "You're not in a workspace yet.\nScan an invitation code to join a\nworkspace!"
      },
      "addActivity": {
        "title": "Add Activity",
        "description": "You don't have any activity yet.\nTap '+' to add a report or note about your asset and keep your team informed."
      },
      "addAsset": {
        "title": "Add Assets",
        "description": "You don't have any assets yet.\nTap '+' to scan and add your first asset to get started."
      },
      "or": "or",
      "newSub": "start a new subscription",
      "here": "here"
    }
  },
  "admin": {
    "menu": {
      "admin": "People",
      "workspaces": "Workspaces"
    }
  },
  "apiKey": {
    "description": "Generate an API key to access the Gripp REST API. Use this key to integrate with external tools and scripts.",
    "generate": "Generate API Key",
    "regenerate": "Regenerate API Key",
    "copy": "Copy to Clipboard",
    "copied": "Copied!",
    "copyWarning": "Copy this key now. You won't be able to see it again.",
    "currentKey": "API Key",
    "created": "Created",
    "lastUsed": "Last Used",
    "regenerateConfirm": "Regenerating will revoke your current API key. Any integrations using it will stop working.",
    "regenerateConfirmYes": "Regenerate",
    "workspaceId": "Workspace ID",
    "copyError": "Unable to copy to clipboard. Please check your browser permissions and try again.",
    "copyWorkspaceIdError": "Unable to copy Workspace ID. Please check your browser permissions and try again."
  },
  "alerts": {
    "addAnother": "Add another",
    "create": {
      "alertName": "Alert Name",
      "asset(s)": "Asset(s)",
      "assetSearchPlaceholder": "Search an asset name",
      "assets": "Assets",
      "doNotAlert": "<0>(Optional)</0><1>Do not alert between:</1>",
      "groupSearchPlaceholder": "Search a group name",
      "groups": "Groups",
      "promptRoutine": "<0>(Optional)</0><1>Select a routine</1><0>to prompt with this alert:</0>",
      "promptRoutinePlaceholder": "no routine selected",
      "title": "Create Alert",
      "what": "1. Choose what:",
      "when": "3. Choose when:",
      "why": "2. Choose why:"
    },
    "setAlert": "Add Alert",
    "setANewAlert": "Set a New Alert",
    "createButton": "Create New",
    "createNewAlert": "Create a New Alert",
    "createAlert": "Create Alert",
    "alert": "Alert",
    "alerts": "Alerts",
    "deleteAlert": "Delete Alert",
    "nextAlert": "Next Alert: ",
    "lastAlert": "Last Alert: ",
    "lastAlertNA": "N/A",
    "confirm": "Confirm",
    "currently": "Currently: ",
    "abovePlaceholder": "above",
    "belowPlaceholder": "below",
    "editAlert": "Edit Alert",
    "intervalValue": "Interval value",
    "newAlert": "New Alert",
    "number": "Number",
    "minDropdownPlaceholder": "When it is above  _____ ",
    "maxDropdownPlaceholder": "When it is below  _____ ",
    "setAlertLogic": "Set Alert Logic",
    "setAlertLogicPlaceholder": "Select an alerting logic",
    "optionalSettings": "Optional Settings",
    "customLabelTitle": "Customize alert title",
    "blackoutDates": "Blackout dates?",
    "startDate": "Start Date",
    "starting": "Starting",
    "minute": "minute",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "day": "day",
    "days": "days",
    "week": "week",
    "weeks": "weeks",
    "month": "month",
    "months": "months",
    "togo": "to go",
    "completions": "completions",
    "recorded": "recorded",
    "elapsed": "elapsed",
    "OR": "OR",
    "or": "or",
    "on": "on",
    "skipped": "skipped",
    "every": "every",
    "Every": "Every",
    "startingValue": "Starting value",
    "startingValuePerAsset": "Starting value per asset",
    "onDate": "On a specific date",
    "onDays": "Every ___ days",
    "onRecurringInterval": "On a recurring time interval",
    "onDayInterval": "Remind me after ___",
    "onDayIntervalUnit": "Interval",
    "dateInterval": {
      "minutes": "Minutes",
      "hours": "Hours",
      "days": "Days",
      "weeks": "Weeks",
      "months": "Months"
    },
    "onDaysSkipped": "Every ___ days routine is incomplete",
    "onRoutineCompletions": "Every ___ times routine is completed",
    "onInterval": "Based upon an interval",
    "selectRoutineToPrompt": "Select Routine to Prompt",
    "selectAlertingLogic": "Select Alerting Logic",
    "customLabelWhenAlertOccurs": "Custom Label When Alert Occurs",
    "selectRoutine": "Select routine",
    "reset": "Reset",
    "edit": {
      "alertName": "Alert Name",
      "asset(s)": "Asset(s)",
      "assets": "Assets",
      "doNotAlert": "Do not alert between",
      "groups": "Groups",
      "none": "None",
      "promptRoutine": "<0>Select a routine</0><1>to prompt with this alert</1>",
      "promptRoutinePlaceholder": "no routine selected",
      "setFor": "This alert is set for",
      "setOn": "Set up the alert on",
      "title": "Edit Alert",
      "when": "When"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Yes",
        "secondaryButton": "Cancel",
        "title": "Are you sure you'd like to delete {{alertName}}?"
      },
      "delete": "Delete",
      "disableAlert": "Disable Alert",
      "enableAlert": "Enable Alert",
      "viewAlertActivities": "View Alert Activities"
    },
    "new": {
      "header": "Alerts > Create Alert"
    },
    "title": "Automation",
    "trigger": {
      "counter": {
        "ceiling": "The counter goes above",
        "daysSinceCompleted": "The routine has not been completed for",
        "daysSinceCompleted-end": "Days",
        "every": "Every",
        "every-end": "Days",
        "floor": "The counter goes below",
        "onCompletionCount": "The routine has been completed every",
        "onCompletionCount-end": "Times",
        "onInterval": "The counter reaches interval of"
      },
      "default": {
        "daysSinceCompleted": "The routine has not been completed for",
        "daysSinceCompleted-end": "Days",
        "every": "Every",
        "every-end": "Days",
        "onCompletionCount": "The routine has been completed every",
        "onCompletionCount-end": "Times"
      }
    },
    "validation": {
      "alertTypeRequired": "Alert type required",
      "inputRequired": "Input required",
      "invalidDate": "Invalid date",
      "startDateRequiredForDays": "Start date required for Days alert type",
      "routineIdRequiredForInterval": "Routine id required for interval"
    },
    "setInterval": "Set interval",
    "numberOfDays": "Number of days",
    "numberOfTimes": "Number of times"
  },
  "asset": {
    "advancedAssetInformation": "Advanced Asset Information",
    "customAlert": {
      "tagAlreadyAdded": "This tag is already added to this asset.",
      "tryAnotherTag": "This Tag is already in use and cannot be selected, please try another tag."
    },
    "delete": {
      "button": "Delete Asset",
      "cancel": "Cancel",
      "confirm": "Delete",
      "title": "Are you sure you want to delete this asset?"
    },
    "description": "Description",
    "descriptionPlaceholder": "Optional",
    "details": "Details",
    "detailsPlaceHolder": "Optional",
    "editTitle": "Asset Info",
    "groups": "Groups",
    "groupsPlaceHolder": "(Optional) Select Group(s)",
    "groupsSearchPlaceHolder": "Search a group name",
    "header": {
      "buttons": {
        "addNew": "Add Report / Note",
        "routines": "Routines",
        "addSomething": "Add Something"
      },
      "recentActivity": "Recent Activity",
      "activity": "Activity"
    },
    "information": "Asset Information",
    "mediaLibrary": "Media Library",
    "name": "Name",
    "namePlaceholder": "What is this?",
    "newIssue": "Something new?",
    "accessRequest": {
      "requestFull": "Request Full Access",
      "requested": "Access Requested",
      "modalTitle": "Request Full Access",
      "modalSubtitle": "Leave a message to let the workspace owner know why you need access.",
      "modalPlaceholder": "Optional message...",
      "modalSubmit": "Send Request"
    },
    "newTitle": "Asset Setup",
    "tagCode": "Gripp ID",
    "qr": {
      "title": "Gripp ID QR Code",
      "viewQrLabel": "View QR code for {{tagCode}}",
      "tagAlt": "Gripp Tag {{tagCode}}"
    },
    "assetPicture": "Take a picture of the asset",
    "newAsset": "New Asset",
    "assetName": "Name",
    "newAdditionalMedia": "Pictures",
    "secondaryDescription": "Description",
    "optionalSetting": "Optional Settings",
    "hideReportAndNoteOptionsAnonymous": "Hide Report & Note options for anonymous visitors",
    "hideReportAndNote": "Report & Note",
    "hideForAnonymousVisitors": "Hide for anonymous visitors",
    "files": {
      "title": "Files",
      "noFiles": "No files found.",
      "addFilesLinks": "Add files / links",
      "addSheetTitle": "Add",
      "addSheetSubtitle": "File, media, or link",
      "uploadFile": "Upload File",
      "addLink": "Add Link",
      "save": "Save",
      "addFile": "Add file",
      "view": "View {{count}} result",
      "view_plural": "View {{count}} results",
      "gallery": "Gallery",
      "file": "File",
      "website": "Website Link",
      "link": "Link",
      "name": "Name",
      "camera": "Camera",
      "unableToPreview": "Unable to preview"
    },
    "detail": {
      "edit": "Edit",
      "delete": "Delete",
      "delete_asset": "Delete Asset",
      "delete_warning": "This action cannot be undone.",
      "confirmDelete": "Delete {{fileName}}?"
    },
    "productType": "Product Type",
    "serialNumber": "Serial Number",
    "addons": "Add-ons ({{count}})",
    "addonsNoProduct": "This asset has no product type. Assign a product to enable add-on selection.",
    "enterTagCode": "Enter Tag Code",
    "add": "Add",
    "cancel": "Cancel",
    "save": "Save",
    "tagCodePlaceholder": "Enter tag code",
    "lookingUpTag": "Looking up tag...",
    "pinnedActivity": "Pinned Activity",
    "viewAll": "View All"
  },
  "assets": {
    "filter": {
      "title": "Filters",
      "search": "Search",
      "recentSearches": "Recent Searches",
      "apply": "Apply",
      "reset": "Reset",
      "viewResults": "View {{count}} results",
      "notGrouped": "Not Grouped",
      "columnButton": "Columns",
      "columnSelection": "Columns",
      "columns": {
        "createdAt": "Created At",
        "createdBy": "Created By",
        "description": "Description",
        "serialNumber": "Serial Number",
        "productName": "Product Name",
        "groups": "Groups",
        "groupNames": "Group Names",
        "lastAddress": "Location",
        "lastScannedAt": "Last Scanned",
        "lastUpdated": "Last Updated",
        "name": "Name (required)",
        "notes": "# of Notes",
        "alerts": "# of Alerts",
        "reports": "# of Active Reports",
        "routines": "# of Routines",
        "addons": "# of Add-ons",
        "tagCode": "Gripp ID",
        "workspaces": "Workspace"
      },
      "groups": "Groups",
      "groupsButton": "Groups",
      "default": "Default",
      "searchPlaceholder": "Search name, description, product, add-ons, or Gripp ID",
      "filterToggle": "Combined filtering:",
      "combinedGroups": "Combined filtering"
    },
    "groups": {
      "addAssetTo": "Add 1 asset to:",
      "addAssetsTo": "Add {{count}} assets to:"
    },
    "list": {
      "createdAt": "Created At",
      "createdDate": "Created Date",
      "createdTime": "Created Time",
      "createdBy": "Created By",
      "description": "Description",
      "serialNumber": "Serial Number",
      "productName": "Product Name",
      "groups": "Groups",
      "groupNames": "Group Names",
      "lastAddress": "Location",
      "lastScannedAt": "Last Scanned",
      "lastScannedDate": "Last Scanned Date",
      "lastScannedTime": "Last Scanned Time",
      "lastUpdated": "Last Updated",
      "lastUpdatedDate": "Last Updated Date",
      "lastUpdatedTime": "Last Updated Time",
      "name": "Name",
      "notes": "Notes",
      "alerts": "Alerts",
      "reports": "Active Reports",
      "routines": "Routines",
      "addons": "Add-ons",
      "tagCode": "Gripp ID",
      "workspaces": "Workspace"
    },
    "menu": {
      "title": "Assets",
      "titleSingular": "Asset"
    },
    "textEmpty": "No assets",
    "topBar": {
      "allAssets": "All Assets",
      "assetSelected": "1 asset selected",
      "assetsSelected": "{{count}} assets selected",
      "results": "{{count}} results"
    },
    "change": "Change",
    "routines": "Routines",
    "routineSearchPlaceholder": "Search routine name",
    "addonsSearchPlaceholder": "Search add-on name"
  },
  "products": {
    "textEmpty": "No products",
    "list": {
      "name": "Name"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Profile"
    }
  },
  "binaryCheck": {
    "button": "Update",
    "instructions1": "A new update is available!",
    "instructions2": "Gripp may not work until then."
  },
  "camera": {
    "Cancel": "Cancel",
    "grippInviteDetected": "Gripp Invite Detected!",
    "grippTagDetected": "Gripp Tag Detected!",
    "noCameraAccess": "No access to camera",
    "notGrippInvite": "Not a Gripp Invitation",
    "notGrippTagg": "Not a Gripp Tag",
    "tryAgain": "Please Try Again",
    "noPermissionModal": {
      "oopsMessage": "Oops! You don’t have permission to\naccess this Gripp tag. 🙈",
      "button": "Got it!",
      "errorMessage": "If you believe this is in error, confirm you\nare invited to the correct workplace or\ncontact Gripp support."
    }
  },
  "changesSaved": "Changes Saved",
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "ok": "OK",
    "close": "Close",
    "create": "Create",
    "download": "Download",
    "reset": "Reset",
    "apply": "Apply",
    "save": "Save",
    "optional": "Optional",
    "value": "Value",
    "delete": "Delete",
    "next": "Next",
    "remove": "Remove",
    "typeMessage": "Type a message...",
    "message": "Message",
    "filter": "Filter",
    "searchOrCreate": "Search or create new",
    "filterSearch": {
      "placeholder": "Search filters",
      "noResults": "No filters match \"{{query}}\""
    },
    "groupAssignments": "Group Assignments",
    "confirmDelete": "Delete {{name}}",
    "deleteWarning": "This action cannot be undone."
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Delete account",
    "cannotUndone": "This action cannot be undone.",
    "confirm": "Confirm Delete",
    "header": "Delete Account",
    "reasonInput": "Please let us know any additional details for deleting your account (optional):",
    "reasonInputNoOptional": "Please let us know any additional details for deleting your account:",
    "submitted": "Your account deletion request has been submitted."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Apply",
      "reset": "Reset"
    }
  },
  "edit": "",
  "email": "Email",
  "features": {
    "title": "Features",
    "assignment": {
      "workspaces": "Workspaces",
      "accounts": "Accounts",
      "workspaceSearchPlaceholder": "Search workspaces...",
      "accountSearchPlaceholder": "Search accounts...",
      "noWorkspaces": "No workspaces found",
      "noAccounts": "No accounts found",
      "name": "Name",
      "email": "Email",
      "phone": "Phone"
    }
  },
  "campaigns": {
    "menu": {
      "title": "Campaigns"
    },
    "page": {
      "title": "Campaigns"
    },
    "list": {
      "empty": "No campaigns found",
      "addCampaign": "Create campaign"
    },
    "columns": {
      "name": "Name",
      "status": "Status",
      "responses": "Responses",
      "groups": "Groups",
      "products": "Products",
      "serialNumber": "Serial Number",
      "lastUpdated": "Last Updated",
      "createdAt": "Created at"
    },
    "create": {
      "panelTitle": "New Campaign"
    },
    "responses": {
      "panelTitle": "Responses"
    },
    "edit": {
      "panelTitle": "Edit Campaign"
    },
    "aggregated": {
      "assetCount": "{{count}} asset",
      "assetCount_plural": "{{count}} assets",
      "replyCount": "{{count}} reply",
      "replyCount_plural": "{{count}} replies"
    },
    "filterToggle": "Campaigns"
  },
  "firstName": "First Name",
  "forbidden": "Forbidden",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Add to Group",
      "addtoNewGroup": "Add to New Group",
      "apply": "Apply",
      "clearGroups": "Clear Groups"
    },
    "searchGroups": "Search groups",
    "noGroups": "No Groups",
    "menu": {
      "title": "Groups",
      "editGroup": "Edit Group"
    },
    "create": {
      "label": "Create a New Group",
      "newGroup": "New Group",
      "save": "Save",
      "validation": {
        "name_required": "Group name is required"
      },
      "create": "Create",
      "placeholder": "e.g. Group of Tractors"
    },
    "list": {
      "name": "Group Name",
      "people": "People",
      "assets": "Assets",
      "reports": "Active Reports",
      "routines": "Routines",
      "assetAlerts": "Asset Alerts",
      "groupAlerts": "Group Alerts"
    },
    "common": {
      "textEmpty": "No group",
      "selectGroup": "Select groups",
      "searchGroup": "Search groups",
      "createGroup": "Create Group",
      "emptyStateMessage": "Create a group by typing directly in the search bar."
    },
    "filter": {
      "searchPlaceholder": "Search group names",
      "columnButton": "Columns",
      "columns": {
        "name": "Group Name",
        "reports": "Active Reports",
        "assets": "Assets",
        "people": "People",
        "routines": "Routines",
        "assetAlerts": "Asset Alerts",
        "groupAlerts": "Group Alerts"
      },
      "columnSelection": "Columns"
    },
    "assignments": {
      "name": "Name",
      "jobTitle": "Job Title",
      "accountType": "Account Type",
      "assetSearchPlaceholder": "Search asset name, description, or group name",
      "accountSearchPlaceholder": "Search by name or title",
      "routineSearchPlaceholder": "Search routine name",
      "groupSearchPlaceholder": "Search group names",
      "addonsSearchPlaceholder": "Search add-on name",
      "emptyAccountList": "No accounts",
      "assets": "Assets",
      "groups": "Groups",
      "people": "People",
      "routines": "Routines"
    },
    "deleteGroup": {
      "deleteGroup": "Delete Group",
      "alertBody1": "Are you sure you want to delete",
      "alertBody2": "Note: ",
      "alertBody3": "This will not delete any assets associated with this ",
      "alertBody4": "group.",
      "delete": "Delete",
      "cancel": "Cancel",
      "toastTitle": "Woosh!",
      "toastMessage": "{{groupName}} has been deleted."
    }
  },
  "help": {
    "menu": {
      "title": "Help"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Alerts",
      "editAlert": "Edit Alert"
    },
    "filter": {
      "searchPlaceholder": "Search alerts...",
      "columnButton": "Columns",
      "statusButton": "Status",
      "columnSelection": "Column Selection",
      "columns": {
        "name": "Name",
        "routineName": "Routine",
        "assetName": "Asset",
        "groupName": "Group",
        "productName": "Product",
        "assetAlerts": "Asset Alerts",
        "lastAlertDate": "Last Alert",
        "nextAlertDate": "Next Alert",
        "createdAt": "Created",
        "status": "Status"
      },
      "status": {
        "label": "Status",
        "all": "All",
        "enabled": "Enabled",
        "disabled": "Disabled"
      }
    },
    "common": {
      "textEmpty": "No alerts found"
    },
    "list": {
      "name": "Name",
      "routineName": "Routine",
      "assetName": "Asset",
      "groupName": "Group",
      "productName": "Product",
      "assetAlerts": "Asset Alerts",
      "lastAlertDate": "Last Alert",
      "nextAlertDate": "Next Alert",
      "createdAt": "Created",
      "status": "Status"
    },
    "deleteAlert": {
      "deleteAlert": "Delete Alert",
      "alertBody1": "Are you sure you want to delete",
      "alertBody2": "Warning:",
      "alertBody3": " Deleting this alert will permanently remove it and all associated data.",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "actions": {
      "enable": "Enable",
      "disable": "Disable",
      "enableSuccess": "Successfully enabled {count} alert(s)",
      "disableSuccess": "Successfully disabled {count} alert(s)"
    }
  },
  "impersonation": {
    "unassigned": "(Unassigned)",
    "picker": {
      "workspaceTitle": "Pick a workspace",
      "userTitle": "Pick a user",
      "searchWorkspaces": "Search workspaces",
      "searchUsers": "Search users",
      "noResults": "No results",
      "userEmptyNoWorkspace": "Select a workspace first to see users.",
      "openFilters": "Open filters",
      "noUser": "Continue without a user"
    },
    "row": {
      "workspaceEmpty": "Select a workspace",
      "userEmpty": "Select a user"
    }
  },
  "invitation": {
    "initial": {
      "heading": "You are invited to {{workspaceName}}!",
      "login": "Log In Key",
      "step1": "Step 1",
      "step1Instructions": "Download Gripp app",
      "step2": "Step 2",
      "step2Instructions": "Use this key to log in"
    },
    "invitePeople": {
      "copiedInvitationLink": "Copied invitation link",
      "copyInviteLink": "Copy invite link",
      "shareInviteLink": "Share invite link",
      "errorCopyingInvitationLink": "Something went wrong when copying the invitation url",
      "invitePeopleForm": "Invite people through emails",
      "invitePeopleQR": "Invite people through QR code",
      "linkAllowsToJoinWorkplace": "This link allows anyone to ask to join your workplace.",
      "emailPlaceholder": "Email",
      "inviteViaEmailLabel": "Invite via Email",
      "inviteSentSuccess": "Invite sent successfully",
      "inviteSentError": "Something went wrong when sending the invite",
      "placeholder": "Emails",
      "send": "Send",
      "submit": "Submit",
      "to": "To"
    },
    "pending": {
      "accepted": "Follow the link sent to your email to sign into your Gripp Account.",
      "cancel": "Cancel",
      "join": "Join",
      "joining": "You are joining {{workspaceName}}",
      "title": "Create Profile"
    },
    "qr": {
      "invitesYou": "invites you to join",
      "showQr": "Show QR to invite others"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Add Note",
      "createReport": "Create Report",
      "getGrippCta": "Get Gripp to see activity, files, & join the conversation!",
      "noteAdded": "Duly Noted!",
      "noteAddedDownloadGrippApp": "Download the Gripp app for even easier note taking!",
      "openAppStore": "Open App Store",
      "report": "Report",
      "reportAddedDownloadGrippApp": "Download the Gripp app for even faster reporting!",
      "reported": "Issue Reported!",
      "routineCompleted": "Boom, update confirmed!",
      "routineCompletedDownloadGrippApp": "Download the Gripp app for the smoothest experience!",
      "dropRoutineTitle": "Done.",
      "dropRoutineSubtitle": "Continue in Gripp for faster scanning, reporting, and history viewing.",
      "dropReportTitle": "Stay in the loop.",
      "dropReportSubtitle": "Continue in Gripp to see replies, add more notes, and see more information.",
      "dropCta": "Get the App",
      "dropCtaA11yLabel": "Get the Gripp app"
    },
    "common": {
      "addPicture": "Pictures",
      "description": "Description",
      "followUp": "Follow-up required?",
      "note": "No, just noting for reference",
      "report": "Yes, follow-up needed",
      "addLabel": "Add a Label",
      "labelSubtitle": "For easier search & filtering.",
      "selectLabel": "Select a label",
      "searchLabel": "Search a label",
      "createLabel": "Create label",
      "emptyStateMessage": "Create a label by typing directly in the search bar.",
      "labelsApplied": "Labels applied"
    },
    "delete": {
      "confirm": "Confirm delete?",
      "button": "Delete Issue",
      "warning": "This action cannot be undone.",
      "cancel": "Cancel",
      "title": "Delete Activity"
    },
    "editModal": {
      "header": "Edit",
      "save": "Save",
      "reviseSubmission": "Revise Submission",
      "pinDescription": "Pinned activity shows in Asset Details"
    },
    "accessRequest": {
      "workspaceAccessRequest": "Workspace access request: {{message}}",
      "requestingFullAccess": "Requesting full workspace access.",
      "approve": "Approve",
      "deny": "Deny",
      "approveA11y": "Approve access request",
      "denyA11y": "Deny access request"
    },
    "latestMessage": {
      "media": "[Media]"
    },
    "menu": {
      "delete": "Delete",
      "edit": "Edit",
      "editRoutine": "Edit Routine",
      "pinToAsset": "Pin to Asset",
      "print": "Print",
      "reassign": "Reassign",
      "reminder": "Reminder",
      "unpin": "Unpin",
      "unpinToAsset": "Unpin to Asset"
    },
    "new": {
      "addIt": "Add Report / Note",
      "editActivity": "Edit Activity",
      "labels": "Labels",
      "optionalPlaceholder": "Optional",
      "placeholder": "What are you seeing?",
      "reassign": "Reassign",
      "reminder": "Reminder",
      "submit": "Submit",
      "title": "Title",
      "type": "Type"
    },
    "quickReminder": {
      "header": "Set Reminder",
      "subheader": "To schedule this report for a future date."
    },
    "adjustCreationDate": {
      "header": "Adjust Creation Date"
    },
    "createdDate": {
      "header": "Created Date"
    },
    "types": {
      "attention": "Urgent",
      "urgent": "Urgent",
      "blocker": "Pending",
      "pending": "Pending",
      "done": "Solved",
      "solved": "Solved",
      "routines": "Routines",
      "note": "Note",
      "campaign": "Campaign"
    },
    "advancedSettings": "Advanced Settings",
    "dateFormat": "MM/DD/YYYY",
    "reminderFor": "Reminder for:",
    "reassign": {
      "instructions": "Which one of the following assets do you want to reassign to?",
      "placeholder": "Search an asset name",
      "saveLabel": "Save",
      "title": "Reassign",
      "unassigned": "{{workspace}} (Unassigned)"
    },
    "topBar": {
      "allReplies": "replies"
    },
    "reminder": {
      "notesOptional": "Notes (Optional)",
      "scheduled": "Scheduled Reminder"
    }
  },
  "job": "",
  "jobTitle": "Job Title",
  "lastName": "Last Name",
  "loading": "Loading",
  "login": {
    "codeSentTo": "A login code was sent to",
    "email": "Email",
    "error": {
      "invalidCredentials": "Invalid credentials",
      "processError": "There was an error processing your request"
    },
    "login": "Log in",
    "password": "Password",
    "resendCode": "Resend code",
    "tabs": {
      "new": {},
      "returning": {
        "title": "I’m returning"
      }
    },
    "tryAnotherMethod": "Try another method",
    "withEmail": "Continue with Email",
    "withPassword": "I have a password",
    "withPhone": "Continue with Phone",
    "continue": "Continue",
    "skip": "Skip",
    "verify": "Verify",
    "didntReceiveCode": "Didn't receive a code?",
    "welcome": "Welcome",
    "signUpToContinue": "Sign up to continue",
    "orUsePrefix": "or use",
    "toggleEmail": "Email",
    "togglePhone": "Phone",
    "verifyCodeSentTo": "A code was sent to",
    "smsConfirmationMessage": "We'll text to confirm your number. It may take a few seconds.",
    "emailConfirmationMessage": "We'll send a verification code to confirm your email. It may take a few seconds.",
    "aboutYourself": "Tell us about yourself",
    "existingAccount": "Already have an Gripp account?"
  },
  "errorBoundary": {
    "title": "Oops!",
    "message": "An unexpected error occurred.",
    "tryAgain": "Try again"
  },
  "logout": "Logout",
  "mentions": {
    "unknownUser": "Unknown User",
    "youAreMentioned": "You are mentioned"
  },
  "media": {
    "validation": {
      "unsupported": "This file couldn't be uploaded. It may be corrupt or in an unsupported format."
    }
  },
  "modalMessages": {
    "completed": "Completed"
  },
  "or": "or",
  "onboarding": {
    "shareInfo": "Share Gripp more about you!",
    "industrial": "Industrial Field",
    "source": "How'd you hear about Gripp?",
    "agriculture": "Agriculture"
  },
  "people": {
    "menu": {
      "people": "People"
    }
  },
  "phone": "Phone number",
  "plusMenu": {
    "add-asset": "Add Asset",
    "invite": "Invite",
    "no-tag": "No Tag?",
    "note": "Note",
    "report": "Report",
    "scan": "Scan"
  },
  "preferences": {
    "language": {
      "languages": {
        "english": "English",
        "spanish": "Spanish",
        "russian": "Russian",
        "kazakh": "Kazakh",
        "afrikaans": "Afrikaans",
        "portuguese": "Portuguese",
        "french": "French"
      },
      "language": "Language",
      "preferredLanguageTitle": "Preferred Language"
    },
    "menu": {
      "title": "Settings"
    },
    "settings": {
      "apiKey": "API Key",
      "notifications": "Notifications",
      "permissions": "Permissions",
      "profile": "Profile",
      "title": "Settings",
      "workSpaces": "Workspaces",
      "workspace_settings": "Workspaces Settings"
    },
    "permissions": {
      "title": "Permissions",
      "allow": "Allow",
      "location": {
        "label": "Location services",
        "description": "Gripp uses your phone location to update the location of your assets when you scan them. At minimum, we ask you to allow location while using the app."
      },
      "camera": {
        "label": "Camera Access",
        "description": "Making notes and reporting issues often require you to take a picture of what you see, so enabling camera access is important to keep yours and others up to date."
      },
      "gallery": {
        "label": "Photo Library Access",
        "description": "Similar to camera, sometimes you already have pictures you want to upload into Gripp. We will only have access to the pictures you choose at the point of upload."
      },
      "pushNotifications": {
        "label": "Push Notifications",
        "description": "Like many apps, be notified when a new alert, issue, or report comes through. You wouldn't want to miss anything important."
      },
      "feature": {
        "scanner": "Camera access is required to scan QR codes and add photos to notes and reports.",
        "gallery": "Photo library access is required to upload pictures from your library to notes and reports."
      }
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Activity Label Notifications",
      "groupNotificationsTitle": "Group Notifications",
      "campaignMessages": "Campaign Messages",
      "issueReplies": "Messages",
      "notificationTitle": "Notifications",
      "schedule": {
        "accept": "Accept",
        "cancel": "Cancel",
        "endTime": "End time:",
        "everyDay": "Every Day",
        "notSet": "Not set",
        "notificationSchedule": "Notification Schedule",
        "set": "Set",
        "startTime": "Start time:",
        "weekDays": "Week Days"
      },
      "severities": {
        "blue": "New Routines",
        "purple": "New Notes",
        "red": "New Reports"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Edit Profile"
      },
      "impersonate": {
        "impersonate": "Impersonate",
        "unimpersonate": "Cancel Impersonation"
      },
      "error": {
        "title": "Error updating profile",
        "generic": "There was an error updating your profile. Please try again.",
        "duplicatedPhone": "This phone number already associated with another account."
      }
    },
    "admin": {
      "title": "Impersonation",
      "workspace": "Workspace",
      "workspaceUsers": "Workspace Users"
    }
  },
  "recent_activities": "Recent Activities",
  "reminders": {
    "deleteReminder": "Delete Reminder",
    "setNewReminder": "set a new reminder for"
  },
  "requestRoutine": {
    "apply": "Apply",
    "header": "Routine",
    "instruction": "Please submit your routine idea:",
    "placeHolder": "What should we start doing?"
  },
  "routines": {
    "admin": {
      "create": "Save",
      "instructions": "Instructions",
      "issuePrefix": "Issue Prefix",
      "reportOnException": "Report on Exception?",
      "routineButtonText": "Routine Button",
      "title": "Title",
      "type": "Type",
      "oneTimeOnly": "One-time only",
      "autoPrompt": "Auto-prompt on asset open",
      "isWorkspaceRoutine": "Workspace Routine",
      "workspaceRoutineBadge": "Workspace",
      "update": "Update",
      "addMedia": "Add Media",
      "image": "Image",
      "link": "Link",
      "linkLabel": "Add Link",
      "linkUrl": "Link URL",
      "linkUrlPlaceholder": "Enter URL (e.g., https://example.com)",
      "invalidUrl": "Invalid URL",
      "enableAutoPinning": "Enable auto-pinning",
      "autoAddLabel": "Auto-add a label"
    },
    "assign": "Assign Routines",
    "copyToWorkspace": {
      "save": "Copy",
      "title": "Copy to Workspace",
      "workspace": "Workspace"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Enable Decimals (Optional)",
        "tallyCounter": "Tally Counter",
        "uom": "Unit of Measure",
        "counterType": "Counter Type"
      },
      "user": {
        "genericCounter": {
          "change": "Change:",
          "initialValue": "Initial Value:",
          "newValue": "New Value:"
        },
        "tallyCounter": {
          "add": "+ Add",
          "added": "Added",
          "adding": "Adding:",
          "instructions": "",
          "newValue": "New Value:",
          "oldValue": "Old Value:",
          "placeholder": "Enter number...",
          "remove": "- Remove",
          "removed": "Removed",
          "removing": "Removing:"
        }
      },
      "counterTypes": {
        "SIMPLE": "Simple",
        "CUMULATIVE": "Cumulative",
        "TALLY": "Tally"
      }
    },
    "time": {
      "admin": {
        "time": "Time type",
        "labelStartTime": "Start Time",
        "labelEndTime": "End Time"
      },
      "timeTypes": {
        "START_END_TIMES": "Start and end times",
        "TIME_ONLY": "Time only",
        "DATE_ONLY": "Date only"
      },
      "message": {
        "time": "Time",
        "start": "Start",
        "end": "End",
        "date": "Date"
      }
    },
    "createNew": "Create a Routine",
    "edit": {
      "header": "Routines > Edit Routine",
      "title": "Edit Routine"
    },
    "editRoutines": {
      "editRoutinesButton": "Edit Routines",
      "label": "Label: ",
      "routineInWorkplace": "All routines available in your workplace",
      "title": "Edit",
      "saveSuccess": "Routines updated successfully",
      "saveError": "Failed to save routines",
      "routineAdded": "The routine '{{title}}' has been added",
      "routineRemoved": "The routine '{{title}}' has been removed",
      "routineReordered": "Routines reordered successfully"
    },
    "exceptions": {
      "addDetails": "Please add additional details or pictures of the issue:",
      "exceptionsNoticed": "{{count}} exception noticed",
      "exceptionsNoticed_plural": "{{count}} exceptions noticed",
      "reportCreated": "A report was created",
      "viewRelatedReport": "View Related Report",
      "viewRelatedRoutine": "View Related Routine"
    },
    "header": {
      "title": "Routines",
      "view": "View",
      "viewAll": "View All"
    },
    "menu": {
      "copyToWorkspace": "Copy to Workspace",
      "delete": {
        "cancel": "Cancel",
        "confirm": "Yes",
        "item": "Delete",
        "title": "Are you sure you want to delete this routine?",
        "blockedTitle": "Routine in use",
        "blockedGeneric": "This routine couldn't be deleted. Please try again."
      },
      "download": "Download",
      "editRoutine": "Edit Routine",
      "export": "Export data",
      "exporting": "Exporting..."
    },
    "message": {
      "messageTitle": "{{name}} completed routine:",
      "added": "added",
      "removed": "removed",
      "originalValue": "Original Value",
      "newValue": "New Value",
      "messageTitleUpdated": "{{name}} made an update"
    },
    "modalCancel": {
      "primary": "Exit without saving.",
      "secondary": "Cancel",
      "title": "Before we go back,"
    },
    "draftModal": {
      "continueDraft": "Continue draft.",
      "startNew": "Start a new routine.",
      "cancel": "Cancel",
      "messageNoDraft": "A draft was saved",
      "messageWithoutCreator": "A draft was saved on {{date}}",
      "messageWithCreator": "A draft was saved by: \n{{creator}} on {{date}}"
    },
    "new": {
      "chooseTypeButton": "Next Step: Choose Options",
      "header": "Routines > Create Routine",
      "title": "Create Routine"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Add option",
        "options": "Options"
      }
    },
    "requestButton": "+ Request Routine",
    "signature": {
      "clear": "Clear",
      "done": "Done",
      "sign": "Sign",
      "signature": "Signature",
      "submit": "Submit"
    },
    "status": {
      "admin": {
        "addStatus": "Add status",
        "statuses": "Statuses",
        "openEndedResponse": "Open Ended Response",
        "otherStatus": "Other _______"
      }
    },
    "submit": "Submit",
    "resubmit": "Resubmit",
    "saveDraft": "Save as draft",
    "types": {
      "COUNTER": "Counter",
      "QUICK_CONFIRM": "Quick Confirm",
      "STATUS": "Status",
      "WORKFLOW": "Mini Form"
    },
    "update": "Update",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Add Question",
          "duplicateQuestion": "Duplicate Question",
          "instructions": "Instructions",
          "page": "Page {{page}}",
          "questionType": "Question Type"
        },
        "question": {
          "addOption": "Add option",
          "exception": {
            "HasResponse": "Has Response",
            "MissingResponse": "Missing Response",
            "Off": "Off",
            "label": "Exception handling:"
          },
          "instructions": "Instructions",
          "multiline": "Multiline",
          "options": "Options",
          "question": "Question {{question}}",
          "barcodeScanner": {
            "allowMultiple": "Allow multiple entries",
            "includeQuantity": "Include quantity field",
            "includeMemo": "Include memo field"
          },
          "location": {
            "includeMemo": "Include memo field"
          }
        },
        "routine": {
          "label": "Routine",
          "select": "Select a routine"
        }
      },
      "execution": {
        "optional": "Optional",
        "submit": "Submit",
        "barcodeScanner": {
          "addAnother": "Add another",
          "placeholder": "Enter or scan a barcode",
          "placeholderManual": "Enter a barcode",
          "quantityPlaceholder": "Qty",
          "quantityLabel": "Qty: {{quantity}}",
          "remove": "Remove entry",
          "scan": "Scan barcode",
          "memoPlaceholder": "Add a note..."
        },
        "location": {
          "placeholder": "Tap to capture location",
          "captureLabel": "Capture current location",
          "memoPlaceholder": "Add a note..."
        }
      },
      "questionTypes": {
        "CHECKBOX": "Multi-Select",
        "COUNTER": "Counter",
        "MEDIA": "Media",
        "QUICK_CONFIRM": "Quick Confirm",
        "RADIO": "Single-Select",
        "ROUTINE": "Routine",
        "SIGNATURE": "Signature",
        "STATUS": "Status",
        "TEXT": "Text",
        "TIME": "Time",
        "LABEL": "Label",
        "BARCODE_SCANNER": "Barcode Scanner",
        "LOCATION": "Location"
      }
    },
    "textEmpty": "No routines",
    "addToGroups": "Add to Groups",
    "addToGroupsDescription": "Assign {{count}} selected routines to groups",
    "list": {
      "name": "Name",
      "type": "Type",
      "groups": "Groups"
    }
  },
  "saveChanges": "Save Changes",
  "unsavedChanges": {
    "title": "Unsaved changes",
    "subtitle": "Do you want to save your progress before continuing?",
    "saveAndExit": "Save & Exit",
    "dontSave": "Don't Save"
  },
  "signOut": "Sign out",
  "support": {
    "genericDescription": "Sometimes hiccups happen, but if you see this page again, please let us know so we can make it right!",
    "sendEmail": "Or email me at",
    "title": "Shoot, we oopsed"
  },
  "tags": {
    "assetName": "Asset Name",
    "batches": {
      "title": "Orders"
    },
    "status": "Status",
    "tagCode": "Tag Number",
    "title": "Tags",
    "updatedAt": "Updated At",
    "version": "Version"
  },
  "textEmptyList": "No data",
  "topNav": {
    "activities": "Activity",
    "add": "Add",
    "assetInfo": "View Asset",
    "assets": "Assets",
    "back": "Back",
    "backButton": {
      "cancel": "Continue editing",
      "confirmBack": "There are unsaved changes!",
      "ok": "Exit without saving"
    },
    "cancel": "Cancel",
    "customAlert": {
      "cancel": "Cancel",
      "deleteAccount": "Are you sure you'd like to delete your account?",
      "exit": "Exit without saving?",
      "signOut": "Are you sure you'd like to sign out?",
      "yes": "Yes",
      "saveProgress": "Save for later."
    },
    "edit": "Edit",
    "editAsset": "Asset Info",
    "invite": "Invite People",
    "moreAssetInfo": "More Asset Info",
    "moreWorkspaceInfo": "More Workspace Info",
    "save": "Save",
    "myHistory": "My History",
    "modify": "Modify"
  },
  "translation": {
    "seeOriginal": "See Original",
    "seeTranslation": "See Translation"
  },
  "versionCheck": {
    "description": "Updates available! Some features may not work until you refresh the browser.",
    "refreshButton": "Refresh"
  },
  "offline": {
    "banner": {
      "title": "You're offline"
    }
  },
  "workspace": {
    "editTitle": "Workspace Info",
    "titleSingular": "Workspace",
    "filter": {
      "searchPlaceholder": "Search name",
      "columnButton": "Columns",
      "tierButton": "Subscription",
      "columnSelection": "Columns",
      "tierSelection": "Subscription",
      "typeSelection": "Type",
      "columns": {
        "name": "Name",
        "owner": "Administrator",
        "type": "Type",
        "subscriptionTierId": "Subscription",
        "assetsCount": "Assets",
        "routinesCount": "Routines",
        "alerts": "Alerts",
        "peopleCount": "People",
        "activitiesCount": "Activities",
        "groupsCount": "Groups",
        "createdAt": "Created At",
        "createdDate": "Created Date",
        "createdTime": "Created Time",
        "createdBy": "Created By",
        "lastScanned": "Last Scanned",
        "lastScannedDate": "Last Scanned Date",
        "lastScannedTime": "Last Scanned Time",
        "updatedAt": "Last Updated",
        "updatedDate": "Last Updated Date",
        "updatedTime": "Last Updated Time",
        "lastActivity": "Last Activity",
        "lastActivityDate": "Last Activity Date",
        "lastActivityTime": "Last Activity Time"
      }
    },
    "types": {
      "PRODUCER": "Producer",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Submit",
      "administratorEmail": "Administrator Email",
      "administratorPhone": "Administrator Phone Number",
      "administratorFirstName": "Administrator First Name",
      "administratorLastName": "Administrator Last Name",
      "copyRoutines": "Copy Routines",
      "title": "Create Workspace",
      "validation": {
        "admin_email_required": "Administrator email is required",
        "admin_first_name_required": "Administrator first name is required",
        "admin_last_name_required": "Administrator last name is required",
        "name_required": "Workspace name is required",
        "valid_emil": "Administrator email must be a valid email address"
      },
      "type": "Type",
      "workspaceName": "Workspace Name",
      "name": "Workspace Name"
    },
    "createButton": "Create Workspace",
    "menu": {
      "editWorkspace": "Edit Workspace",
      "duplicateWorkspace": "Duplicate Workspace"
    },
    "duplicate": {
      "title": "Duplicate Workspace",
      "sourceLabel": "Duplicating from",
      "contentToCopy": "Content to copy",
      "activities": "Activities",
      "assets": "Assets",
      "routines": "Routines",
      "people": "People",
      "alerts": "Alerts",
      "groups": "Groups",
      "duplicateButton": "Duplicate Workspace"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Delete Workspace",
      "alertBody1": "Are you sure you want to delete",
      "alertBody2": "Note: ",
      "alertBody3": "This will not delete any assets associated with this ",
      "alertBody4": "workspace.",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "list": {
      "name": "Name",
      "owner": "Administrator",
      "type": "Type",
      "assetsCount": "Assets",
      "routinesCount": "Routines",
      "alerts": "Alerts",
      "peopleCount": "People",
      "activitiesCount": "Activities",
      "groupsCount": "Groups",
      "createdAt": "Created At",
      "createdDate": "Created Date",
      "createdTime": "Created Time",
      "createdBy": "Created By",
      "lastScanned": "Last Scanned",
      "lastScannedDate": "Last Scanned Date",
      "lastScannedTime": "Last Scanned Time",
      "updatedAt": "Last Updated",
      "updatedDate": "Last Updated Date",
      "updatedTime": "Last Updated Time",
      "lastActivity": "Last Activity",
      "lastActivityDate": "Last Activity Date",
      "lastActivityTime": "Last Activity Time"
    }
  },
  "permissions": {
    "backButton": "Back",
    "continueButton": "Continue",
    "enableInSettings": "You must enable this permission in system menu to continue.",
    "openSetting": "Open Settings",
    "welcome": {
      "title": "Welcome To Gripp!",
      "description1": "To use Gripp, we need to enable several permissions.",
      "description2": "We’ll walk you through each one to explain why we need it.",
      "description3": "All settings can be adjusted through your phone’s settings at any time."
    },
    "location": {
      "initial": {
        "title": "Access to your location, to track your assets.",
        "description1": "Gripp uses your phone location to update the location of your assets when you scan them.",
        "description2": "At minimum, we ask you to allow location while using the app."
      },
      "denied": {
        "title": "Location access, to track your assets.",
        "description1": "Location helps keep track of your assets."
      },
      "button": "Continue"
    },
    "camera": {
      "initial": {
        "title": "Access to your camera, to capture, message & report.",
        "description1": "Making notes and reporting issues often require you to take a picture of what you see."
      },
      "denied": {
        "title": "Camera access, to capture, message & report.",
        "description1": "Camera access allows you to capture and report issues effortlessly!."
      },
      "button": "Continue"
    },
    "gallery": {
      "initial": {
        "title": "Access to your photo gallery, to upload pictures.",
        "description1": "Sometimes you already have pictures you want to upload into Gripp.",
        "description2": "Gripp will only have access to the pictures you choose at the point of upload."
      },
      "denied": {
        "title": "Photo gallery access, to upload pictures.",
        "description1": "Gallery access allows you to upload pictures you choose."
      },
      "button": "Continue"
    },
    "notification": {
      "initial": {
        "title": "Stay updated with notifications.",
        "description1": "Be notified when a new alert, issue, or report comes through.",
        "description2": "These are for team notifications only and are not related to marketing notifications."
      },
      "denied": {
        "title": "Notifications, to stay updated.",
        "description1": "Get team alerts, issues, and reports—no marketing messages."
      },
      "button": "Continue"
    },
    "allSet": "All set, let's get Gripp'n!"
  },
  "routine": {
    "list": {
      "name": "Name",
      "type": "Routine Type",
      "groups": "Groups",
      "routines": "Routines",
      "oldRoutines": "Old Routines",
      "asset": {
        "name": "Name",
        "description": "Description",
        "groups": "Groups"
      }
    },
    "filter": {
      "searchPlaceholder": "Search routine name",
      "columnButton": "Columns",
      "columnSelection": "Columns",
      "columns": {
        "name": "Name",
        "type": "Routine Type",
        "assetsCount": "Assets",
        "addonsCount": "Add-ons",
        "allAssetsCount": "All Assets",
        "submissionsCount": "Submissions",
        "groups": "Groups",
        "groupNames": "Group Names",
        "lastSubmitted": "Last Submitted",
        "updatedAt": "Last Edited",
        "createdAt": "Date Created",
        "workspace": "Workspace"
      }
    },
    "rowHeader": {
      "routineSelected": "1 routine selected",
      "routinesSelected": "{{count}} routines selected"
    },
    "permittedRoles": {
      "label": "Permitted Roles",
      "noRoles": "No roles available"
    }
  },
  "product": {
    "change": "Change",
    "list": {
      "products": "Products",
      "name": "Name",
      "description": "Description",
      "assetsCount": "Assets",
      "filesCount": "Files",
      "addonsCount": "Add-ons",
      "routines": "Routines",
      "alerts": "Asset Alerts",
      "productAlerts": "Product Alerts",
      "createdAt": "Created At",
      "updatedAt": "Last Updated"
    },
    "filter": {
      "searchPlaceholder": "Search product name",
      "columnButton": "Columns",
      "columns": {
        "name": "Name",
        "description": "Description",
        "assetsCount": "Assets",
        "filesCount": "Files",
        "addonsCount": "Add-ons",
        "routines": "Routines",
        "alerts": "Asset Alerts",
        "productAlerts": "Product Alerts",
        "createdAt": "Created At",
        "updatedAt": "Last Updated"
      },
      "columnSelection": "Columns"
    },
    "create": {
      "label": "Create a New Product",
      "validation": {
        "name_required": "Product name is required"
      },
      "cancel": "Cancel",
      "create": "Create",
      "placeholder": "e.g. Product 1"
    },
    "delete": {
      "button": "Delete Product",
      "cancel": "Cancel",
      "confirm": "Yes",
      "title": "Are you sure you want to delete the product {{productName}}?"
    },
    "detail": {
      "addon_options": "Add-on Options",
      "no_addon_options": "There are no add-on options for this product.",
      "add_more": "Add more",
      "description": "Description",
      "details": "Details",
      "files": {
        "placeholder": "Any additional files to upload? (data plates, oem stickers, etc.)",
        "addFilesLinks": "Add files / links"
      },
      "save": "Save",
      "cancel": "Cancel",
      "profile": "Product Profile",
      "assets": "Assets",
      "routines": "Routines",
      "noAvailableRoutines": "No available routines to add",
      "edit": "Edit",
      "delete": "Delete",
      "confirmDelete": "Are you sure you want to delete the product {{fileName}}?"
    },
    "specifications": {
      "title": "All Specifications",
      "upload": "Upload Data",
      "download": "Download",
      "add_more": "Add more",
      "label_placeholder": "Specification name",
      "value_placeholder": "Value",
      "delete_confirm": "Are you sure you want to delete this specification?",
      "upload_coming_soon": "CSV upload functionality coming soon",
      "download_coming_soon": "CSV download functionality coming soon",
      "upload_success": "Specifications uploaded successfully",
      "upload_error": "Failed to upload specifications. Please try again.",
      "download_error": "Failed to download specifications. Please try again.",
      "download_title": "Download Specifications",
      "no_data_to_download": "No specifications to download",
      "sharing_not_available": "File sharing is not available on this device"
    },
    "assignments": {
      "assets": "Assets",
      "routines": "Routines",
      "files": "Files",
      "addons": "Add-ons",
      "searchPlaceholder": "Search name",
      "assetSearchPlaceholder": "Search asset name",
      "routineSearchPlaceholder": "Search routine name",
      "fileSearchPlaceholder": "Search file name",
      "addonSearchPlaceholder": "Search add-on name"
    }
  },
  "file": {
    "list": {
      "files": "Files",
      "name": "Name",
      "products": "Products",
      "assets": "Assets",
      "addons": "Add-ons",
      "categories": "Categories",
      "lastUpdated": "Last Updated",
      "createdAt": "Created At"
    },
    "filter": {
      "searchPlaceholder": "Search file name",
      "columnButton": "Columns",
      "categories": "Categories",
      "searchCategories": "Search categories",
      "deleteCategory": "Delete Category",
      "deleteCategoryMessage": "Are you sure you want to delete \"{{categoryName}}\"? This will remove the category from {{fileCount}} files.",
      "columns": {
        "name": "Name",
        "productsCount": "Products",
        "assetsCount": "Assets",
        "addonsCount": "Add-ons",
        "categories": "Categories",
        "updatedAt": "Last Updated",
        "createdAt": "Created At"
      },
      "columnSelection": "Columns"
    },
    "assignments": {
      "productsSearchPlaceholder": "Search product name",
      "addonsSearchPlaceholder": "Search add-on name"
    },
    "create": {
      "label": "Add File",
      "linkLabel": "Add Link",
      "title": "Title",
      "linkUrl": "Link URL",
      "category": "Category",
      "file": "File (one file only)",
      "link": "Link (one link only)",
      "add": "Add",
      "addLink": "Add Link",
      "titlePlaceholder": "Enter file title",
      "linkUrlPlaceholder": "Enter URL (e.g., https://example.com)",
      "categoryPlaceholder": "Select categories",
      "categorySearchPlaceholder": "Search categories",
      "createCategory": "Create Category",
      "enterCategoryNamePlaceholder": "Enter category name",
      "creatingCategory": "Creating...",
      "selectCategory": "Select categories",
      "searchCategory": "Search categories",
      "emptyStateMessage": "Create a category by typing directly in the search bar.",
      "clickToUpload": "Click to upload file",
      "linkPlaceholder": "Enter URL (e.g., https://example.com)",
      "validation": {
        "title_required": "File title is required",
        "category_required": "At least one category is required",
        "link_required": "Link URL is required",
        "link_invalid": "Please enter a valid URL"
      },
      "uploadError": "Failed to upload file. Please try again.",
      "linkError": "Failed to create link. Please try again.",
      "placeholder": "File Name"
    },
    "dropdown": {
      "createFile": "Create File",
      "file": "File",
      "link": "Link"
    },
    "tabs": {
      "products": "Products",
      "addons": "Add-ons"
    },
    "deleteFile": {
      "deleteFile": "Delete File",
      "alertBody1": "Are you sure you want to delete",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "assets": {
      "title": "Assets",
      "name": "Name",
      "description": "Description",
      "lastScanned": "Last Scanned",
      "lastAddress": "Last Address",
      "lastUpdated": "Last Updated",
      "noAssets": "No assets found"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Add-Ons",
      "name": "Name",
      "product": "Products",
      "asset": "Assets",
      "media": "Files",
      "routines": "Routines",
      "createdAt": "Created At",
      "updatedAt": "Last Updated",
      "addon": "Addon"
    },
    "filter": {
      "searchPlaceholder": "Search add-on name",
      "columnButton": "Columns",
      "columns": {
        "name": "Name",
        "product": "Products",
        "asset": "Assets",
        "media": "Files",
        "routines": "Routines",
        "createdAt": "Created At",
        "updatedAt": "Last Updated"
      },
      "columnSelection": "Columns"
    },
    "create": {
      "label": "Create Add-on",
      "validation": {
        "name_required": "Add-on name is required"
      },
      "cancel": "Cancel",
      "create": "Create",
      "placeholder": "e.g. Add-on 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Search product name",
      "mediaSearchPlaceholder": "Search file name",
      "routineSearchPlaceholder": "Search routine name",
      "success": "Products assigned to add-on successfully",
      "error": "Must provide product IDs"
    },
    "files": {
      "title": "Files",
      "name": "Name",
      "type": "Type",
      "extension": "Extension",
      "textEmpty": "No files found",
      "addFilesLinks": "Add files / links",
      "save": "Save",
      "delete": "Delete",
      "list": {
        "name": "Name",
        "categories": "Categories"
      }
    },
    "textEmpty": "Tap '+ Create Add-on' to add your first add-on.",
    "edit": {
      "label": "Edit Add-on",
      "save": "Save"
    },
    "deleteAddon": "Delete Add-on"
  },
  "labels": {
    "confirmTextLine1": "Are you sure you want to delete the \"{{labelName}}\" label?",
    "confirmTextLine2": "This will remove the label from {{activityCount}} existing activities.",
    "cancel": "Cancel",
    "delete": "Delete",
    "editLabels": "Edit Labels",
    "labels": "Labels",
    "yes": "Yes"
  },
  "categories": {
    "confirmTextLine1": "Are you sure you want to delete the \"{{categoryName}}\" category?",
    "confirmTextLine2": "This will remove the category from {{fileCount}} existing files.",
    "cancel": "Cancel",
    "delete": "Delete",
    "editCategories": "Edit Categories",
    "categories": "Categories",
    "yes": "Yes"
  },
  "home": {
    "menu": {
      "title": "Home"
    },
    "page": {
      "title": "Home"
    },
    "search": {
      "placeholder": "Search"
    },
    "map": {
      "label": "Activity map",
      "loading": "Loading map…",
      "error": "Unable to load map data.",
      "empty": "No data for this period.",
      "emptyAssets": "No assets for this period.",
      "emptyActivity": "No activity for this period.",
      "emptyRoutines": "No routine activity for this period.",
      "emptyProducts": "No products for this period.",
      "noResults": "No matches for this search."
    },
    "activity": {
      "title": "Activity",
      "total": "{{count}} total",
      "viewAll": "View all",
      "solved": "Solved",
      "pending": "Pending",
      "urgent": "Urgent",
      "error": "Could not load activity data",
      "empty": "No activity for this period",
      "plot": "Plot activities on the map"
    },
    "cards": {
      "viewAll": "View all",
      "error": "Could not load data"
    },
    "assets": {
      "title": "Assets",
      "empty": "No assets for this period",
      "plot": "Plot assets on the map",
      "filterBy": "Filter map by {{status}}"
    },
    "routines": {
      "title": "Routines",
      "empty": "No routines",
      "plot": "Plot routine locations on the map",
      "filterBy": "Plot {{name}} on the map"
    },
    "products": {
      "title": "Products",
      "empty": "No products",
      "plot": "Plot products on the map",
      "filterBy": "Plot {{name}} on the map"
    },
    "campaigns": {
      "title": "Campaigns",
      "empty": "No campaigns"
    },
    "customers": {
      "title": "Customers",
      "empty": "No customers",
      "sample": "Sample data",
      "active": "Active",
      "pending": "Pending",
      "new": "New"
    },
    "plot": {
      "activity": "Showing activities",
      "asset": "Showing assets",
      "routine": "Showing routine locations",
      "product": "Showing products"
    },
    "timeRange": {
      "label": "Time range",
      "today": { "label": "Today", "a11y": "Today" },
      "7d": { "label": "7D", "a11y": "Last 7 days" },
      "30d": { "label": "30D", "a11y": "Last 30 days" },
      "90d": { "label": "90D", "a11y": "Last 90 days" },
      "1y": { "label": "1Y", "a11y": "Last year" },
      "all": { "label": "All", "a11y": "All time" }
    }
  },
  "integrations": {
    "providers": {
      "geotab": "GeoTab",
      "johnDeere": "John Deere Operations",
      "caseIh": "Case IH"
    },
    "attribution": {
      "autoSynced": "Auto-synced"
    },
    "digest": {
      "title": "Synced {{count}} asset",
      "title_plural": "Synced {{count}} assets",
      "titleSegment": "{{provider}} synced {{count}} asset",
      "titleSegment_plural": "{{provider}} synced {{count}} assets",
      "failedDescription": "Sync failed — readings may be out of date",
      "readingsCount": "{{count}} reading",
      "readingsCount_plural": "{{count}} readings",
      "faultsCount": "{{count}} fault",
      "faultsCount_plural": "{{count}} faults",
      "detailTitle": "Sync digest",
      "detailEmpty": "No per-asset detail available"
    },
    "readings": {
      "fallbackRoutineName": "Reading"
    }
  }
}
